"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const FeedbackModal_1 = require("decentraland-ui/dist/components/BuyManaWithFiatModal/FeedbackModal");
const Network_1 = require("decentraland-ui/dist/components/BuyManaWithFiatModal/Network");
const network_1 = require("decentraland-ui/dist/lib/network");
const utils_1 = require("../../../modules/analytics/utils");
const types_1 = require("../../../modules/gateway/types");
const utils_2 = require("../../../modules/translation/utils");
const transactionStatuses = {
    [types_1.PurchaseStatus.PENDING]: FeedbackModal_1.TransactionStatus.PENDING,
    [types_1.PurchaseStatus.COMPLETE]: FeedbackModal_1.TransactionStatus.SUCCESS,
    [types_1.PurchaseStatus.FAILED]: FeedbackModal_1.TransactionStatus.FAILURE,
    [types_1.PurchaseStatus.CANCELLED]: FeedbackModal_1.TransactionStatus.FAILURE
};
const camelToSnakeCase = (str) => str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
const propsToTranslateByStatus = {
    [FeedbackModal_1.TransactionStatus.PENDING]: [
        'title',
        'statusTitle',
        'description',
        'goToText'
    ],
    [FeedbackModal_1.TransactionStatus.SUCCESS]: [
        'title',
        'description',
        'cta',
        'viewTransaction'
    ],
    [FeedbackModal_1.TransactionStatus.FAILURE]: [
        'title',
        'statusTitle',
        'description',
        'cta',
        'secondaryCta'
    ]
};
const getDefaultFeedbackTranslations = ({ network, gateway }, status) => {
    const basePath = `@dapps.buyManaWithFiat.feedback_modal.${status}`;
    return Object.fromEntries(propsToTranslateByStatus[status].map(prop => [
        prop,
        (0, utils_2.t)(`${basePath}.${camelToSnakeCase(prop)}`, {
            network: (0, network_1.getNetworkName)(network),
            gateway: Network_1.gatewaysNames[gateway]
        })
    ]));
};
const BuyManaWithFiatFeedbackModal = ({ metadata: { purchase, goToUrl, transactionUrl }, onTryAgain, onSelectOtherProvider, onClose }) => {
    const { network, gateway, status: purchaseStatus } = purchase;
    const transactionStatus = transactionStatuses[purchaseStatus];
    const analytics = (0, utils_1.getAnalytics)();
    const handleCtaClick = (0, react_1.useCallback)(() => {
        switch (transactionStatus) {
            case FeedbackModal_1.TransactionStatus.SUCCESS:
                onClose();
                break;
            case FeedbackModal_1.TransactionStatus.FAILURE:
                analytics.track('Try again with same Gateway', { network, gateway });
                onTryAgain(network, gateway);
                onClose();
                break;
            default:
                break;
        }
    }, [transactionStatus, analytics, network, gateway, onClose, onTryAgain]);
    const handleSecondaryCtaClick = (0, react_1.useCallback)(() => {
        if (transactionStatus === FeedbackModal_1.TransactionStatus.FAILURE) {
            analytics.track('Select other gateway', {
                network,
                previousGateway: gateway
            });
            onSelectOtherProvider(network);
            onClose();
        }
    }, [
        transactionStatus,
        analytics,
        network,
        gateway,
        onSelectOtherProvider,
        onClose
    ]);
    return (react_1.default.createElement(FeedbackModal_1.FeedbackModal, { open: true, status: transactionStatus, selectedNetwork: purchase.network, selectedGateway: purchase.gateway, goToUrl: goToUrl, transactionUrl: transactionUrl, onClickCta: handleCtaClick, onClickSecondaryCta: handleSecondaryCtaClick, onClose: onClose, i18n: getDefaultFeedbackTranslations(purchase, transactionStatus) }));
};
exports.default = react_1.default.memo(BuyManaWithFiatFeedbackModal);
//# sourceMappingURL=BuyManaWithFiatFeedbackModal.js.map